/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

import { blog, dashboard, doctor, doctorschedule, logout, menuicon04, menuicon06, menuicon08, menuicon09, menuicon10, menuicon11, menuicon12, menuicon14, menuicon15, menuicon16, patients, sidemenu } from './imagepath';
import Scrollbars from "react-custom-scrollbars-2";
import { useAuth } from '../services/authentication_API/authService';


const Sidebar = (props) => {



  const {user, token}=useAuth()
    console.log(user,   token)

  

  const [sidebar, setSidebar] = useState("");
  const handleClick = (e, item, item1, item3) => {
    const div = document.querySelector(`#${item}`);
    const ulDiv = document.querySelector(`.${item1}`);
    e?.target?.className ? ulDiv.style.display = 'none' : ulDiv.style.display = 'block'
    e?.target?.className ? div.classList.remove('subdrop') : div.classList.add('subdrop');
    setSidebar("settings");
  }

  useEffect(() => {
    if (props?.id && props?.id1) {
      const ele = document.getElementById(`${props?.id}`);
      handleClick(ele, props?.id, props?.id1);
    }
  }, [])
 

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  return (
    <>
      <div className="sidebar " id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div
              id="sidebar-menu"
              className="sidebar-menu "
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              <ul>
                {/* For Admin Role */}

                {user === "superadmin" && (
                <>            
                <li className="menu-title">Main</li>

                {/* For Admin Dashboard */}
                {<li className="submenu">
                  <Link
                    to="/admin-dashboard"
                    className={
                      props?.activeClassName === "admin-dashboard"
                        ? "active"
                        : ""
                    }
                  >
                    <span className="menu-side">
                      <img src={dashboard} alt="" />
                    </span>{" "}
                    <span> Admin Dashboard </span>
                  </Link>
                </li>}  

                
                <li className="submenu">
                  <Link
                    to="/hospitallist"
                    className={
                      props?.activeClassName === "hospital"
                        ? "active"
                        : ""
                    }
                  >
                    <span className="menu-side">
                    <img src={doctor} alt="" />
                    </span>{" "}
                    <span> Hospitals </span>
                  </Link>
                </li>
                <li className="submenu">
                  <Link
                    to="/doctorlist"
                    className={
                      props?.activeClassName === "doctor"
                        ? "active"
                        : ""
                    }
                  >
                    <span className="menu-side">
                    <img src={doctor} alt="" />
                    </span>{" "}
                    <span> Doctors </span>
                  </Link>
                </li>

                </>)}  

                {/* For Doctor Role */}
                {user === "doctor" && (
                <>            
                

                {/* For Admin Dashboard */}
                <li className="submenu">
                  <Link
                    to="/doctor-dashboard"
                    className={
                      props?.activeClassName === "doctor-dashboard"
                        ? "active"
                        : ""
                    }
                  >
                    <span className="menu-side mt-2">
                      <img src={dashboard} alt="" />
                    </span>{" "}
                    <span> Doctor Dashboard </span>
                  </Link>
                </li>

                <li className="submenu">
                  <Link to="#" id="menu-item1" onClick={(e) => handleClick(e, "menu-item1", "menu-items1")}>
                    <span className="menu-side">
                      <img src={patients} alt="" />
                    </span>{" "}
                    <span>Settings </span> <span className="menu-arrow" />
                  </Link>
                  <ul  className="menu-items1"  >
                    <li>
                      <Link className={props?.activeClassName === 'medicines' ? 'active' : ''} to="/medicines-Settings">Medicines</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'symptoms' ? 'active' : ''}  to="/symptoms-Settings">Symptoms</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'findings' ? 'active' : ''}  to="/findings-Settings">Findings</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'diagnoses' ? 'active' : ''} onClick={()=>document.body.classList.remove("expand-menu")}  to="/diagnoses-Settings">Diagnoses</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'investigations' ? 'active' : ''} to="/investigations-Settings">Investigations</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'instructions' ? 'active' : ''} to="/instructions-Settings">Instructions</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'procedures' ? 'active' : ''} to="/procedures-Settings">Procedures</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'receptionistlist' ? 'active' : ''} to="/receptionistlist">Reception</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'add-shedule' ? 'active' : ''} to="/manage-shifts">Doctor Schedule</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'print-settings' ? 'active' : ''} to="/print-settings">Print Settings</Link>
                    </li>
                     <li>
                      <Link className={props?.activeClassName === 'select-module' ? 'active' : ''} to="/select-module">Modules</Link>
                    </li>
                    {/* <li>
                      <Link className={props?.activeClassName === 'AppointmentSettings' ? 'active' : ''} to="/Appointment-Settings">Appointment Settings</Link>
                    </li>
                    <li>
                      <Link className={props?.activeClassName === 'consultantion-fee' ? 'active' : ''} to="/consultantion-fee">Consultantion Fee</Link>
                    </li> */}
                  </ul>
                </li>
                </>)}

                {user === "receptionist" && (
                <>
                <li className="menu-title">Main</li>
                    <li className="submenu">
                      <Link
                        className={
                          props?.activeClassName === "receptionist-dashboard"
                            ? "active"
                            : ""
                        }
                        to="/receptionist-dashboard"
                      >
                         <span className="menu-side">
                         <img src={dashboard} alt="" />
                         </span>{" "}
                         <span className="text-wrap overflow-wrap-break w-100">Receptionist Dashboard</span>
                      </Link>
                    </li>
                    <li className="submenu">
                      <Link
                        className={
                          props?.activeClassName === "patient"
                            ? "active"
                            : ""
                        }
                        to="/patientslist"
                      > 
                        <span className="menu-side">
                        <img src={patients} alt="" />
                        </span>{" "}
                        <span>Patient</span>
                      </Link>
                    </li>
              
                </>)}


                
                
                
              </ul>
              
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
}
export default Sidebar
